import React, { useEffect, useState } from 'react';
import { GetNewVehicleDashboard } from '../../../../Core/Service/dashbordService';
import { Button, ButtonGroup, Card, CircularProgress, Grid, Hidden } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import CardUserInterface from '../cardUserInterface';
import { assign, filter, set } from 'lodash';
import { _uniqueId } from 'lodash/uniqueId';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        background: 'white',
        border: '2px solid #f5f5f5 ',
        Opacity: 0.9,
        minWidth: 110,
        padding: '5px 0px',
        margin: 3,
        borderRadius: 3
    },
    CardRoot: {
        width: '100%',
        margin: 3,
        border: '2px solid white ',
        Opacity: 0.9,
        minWidth: 120,
        padding: '5px 0px',
        background: 'white',
        borderRadius: 10
    }
}));

const scrollNext = (id) => {
    document.getElementById('WorkFlow-Btn').scrollBy({ left: 100, top: 0, behavior: 'smooth' });
};

const scrollPrev = (id) => {
    document.getElementById('WorkFlow-Btn').scrollBy({ left: -100, top: 0, behavior: 'smooth' });
};

const WipsDate = [
    { id: 2, name: 'Sales' },
    { id: 1, name: 'Assigned Date' }
];

function getUniqueObjectsByProperty(arrayOfObjects, property) {
    const uniqueValues = [...new Set(arrayOfObjects.map((obj) => obj[property]))];
    const uniqueObjects = uniqueValues.map((value) => arrayOfObjects.find((obj) => obj[property] === value));
    return uniqueObjects;
}

const SalesRecordCard = ({ workflowData, workflow, total, classes, onClick }) => {
    return (
        <Card className={classes?.root} style={{ background: 'white', color: 'black', padding: 0 }} onClick={onClick ? () => onClick(workflowData) : null}>
            <div style={{ textAlign: 'left', cursor: 'pointer', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', padding: '5px 20px' }}>
                <span style={{ fontSize: 14, marginBottom: 6 }}>{workflow}</span>
                <div style={{ fontSize: 30, fontWeight: 600 }}>{total}</div>
            </div>
        </Card>
    );
};

const processSalesData = (data) => {
    let salesRecordAllTotal = 0;
    let sortedSalesRecordsList = data.map((obj) => ({ ...obj }));
    let sumOFByTimeForALL = [];

    sortedSalesRecordsList = sortedSalesRecordsList.reduce((acc, obj) => {
        const index = acc.find((item) => item.workflowID === obj.workflowID);
        if (index) {
            index.total += obj.total;
            return acc;
        }
        acc.push({ ...obj });
        return acc;
    }, []);

    sumOFByTimeForALL = data.reduce((acc, obj) => {
        const index = acc.find((item) => item.bid === obj.bid);
        if (index) {
            index.lessThan24HoursOld += obj.lessThan24HoursOld;
            index.between1And5DaysOld += obj.between1And5DaysOld;
            index.between5And10DaysOld += obj.between5And10DaysOld;
            index.between10And20DaysOld += obj.between10And20DaysOld;
            index.between21And30DaysOld += obj.between21And30DaysOld;
            index.over30DaysOld += obj.over30DaysOld;
            index.preBooking += obj.preBooking;
            index.between1to10Days += obj.between1to10Days;
            index.between11And20Days += obj.between11And20Days;
            index.between21And30Days += obj.between21And30Days;
            index.overdueOver30DaysOld += obj.overdueOver30DaysOld;
            index.overdueArchived += obj.overdueArchived;
            return acc;
        }
        acc.push({ ...obj });
        return acc;
    }, []);

    salesRecordAllTotal = sortedSalesRecordsList.reduce((total, obj) => total + obj.total, 0);

    return { salesRecordAllTotal, sortedSalesRecordsList, sumOFByTimeForALL };
};

const getUniqueTitles = (arrayOfObjects, property, uniqueId) => {
    const { name, id } = property;
    const TitlesMap = new Map();
    arrayOfObjects.forEach((item) => {
        TitlesMap.set(item[uniqueId], { name: item[name], id: item[id] });
    });
    return Array.from(TitlesMap.values());
};

const NewSalesDashboardDetailsScreen = (props) => {
    const classes = useStyles();
    const history = useHistory();

    const [state, setState] = useState({
        salesRecordList: [],
        sumOFByTimeForALL: [],
        uniqueBranches: [],
        assignedDate: 2,
        returnReason: [],
        returnReasonTitleList: [],
        assignuserTitles: [],
        filteredAssignedList: [],
        returnReasonList: []
    });

    const [showLoader, setShowLoader] = useState(true);

    const returnReasonsAggriate = (data) => {
        let returnReasonList = [];
        if (state.byTimeBranch === 'Default') {
            returnReasonList = data
                .reduce((acc, obj) => {
                    const index = acc.find((item) => item.workflowID === obj.workflowID && item.returnReasonID === obj.returnReasonID);
                    if (index) {
                        index.total += obj.total;
                        return acc;
                    }
                    acc.push({ ...obj });
                    return acc;
                }, [])
                .map((obj) => ({ ...obj, label: obj.rr, value: obj.total }));
        } else {
            returnReasonList = data
                .reduce((acc, obj) => {
                    const index = acc.find(
                        (item) => item.workflowID === obj.workflowID && item.returnReasonID === obj.returnReasonID && item.bn === state.byTimeBranch
                    );
                    if (index) {
                        index.total += obj.total;
                        return acc;
                    }
                    acc.push({ ...obj });
                    return acc;
                }, [])
                .map((obj) => ({ ...obj, label: obj.rr, value: obj.total }));
        }

        const filterReturnReason = returnReasonList.filter((item) => item.workflowID === state.returnReasonTitle);

        setState((st) => ({ ...st, returnReasonList: filterReturnReason }));
    };

    useEffect(() => {
        if (state.returnReason.length > 0) {
            returnReasonsAggriate(state.returnReason);
        }
    }, [state.returnReason, state.byTimeBranch, state.returnReasonTitle]);

    useEffect(() => {
        setShowLoader(true);
        const fetchData = async () => {
            let res = await GetNewVehicleDashboard(props.processID || 2);
            const assignedUser = res.data.assignedUser || [];
            const returnReason = res.data.returnreason || [];
            const uniqueBranches = getUniqueObjectsByProperty([...res.data.salesRecord], 'bid').map((a) => ({ name: a.bn, id: a.bid }));
            const { salesRecordAllTotal, sortedSalesRecordsList, sumOFByTimeForALL } = processSalesData(res.data.salesRecord);

            setState((st) => ({
                ...st,
                salesRecordList: sortedSalesRecordsList,
                salesRecordAllTotal,
                sumOFByTimeForALL,
                uniqueBranches,
                returnReason,
                assignuserTitles: getUniqueTitles(assignedUser, { name: 'workflow', id: 'workflowID' }, 'workflowID'),
                returnReasonTitleList: getUniqueTitles(returnReason, { name: 'name', id: 'workflowID' }, 'workflowID'),
                assignedUserList: assignedUser.map((a) => ({ ...a, label: a.userName, value: a.total })),
                assignedUser: assignedUser[0]?.workflowID,
                returnReasonTitle: returnReason[0]?.workflowID
            }));
            setShowLoader(false);
        };
        return fetchData();
    }, [props.processID]);

    useEffect(() => {
        if (state.sumOFByTimeForALL.length > 0) {
            const btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));
            findByTimeValues(btTimeData?.branchShortName || 'Default');
        }
    }, [state.sumOFByTimeForALL]);

    let findByTimeValues = (val) => {
        let indexObj = {};

        if (val === 'Default') {
            if (state.sumOFByTimeForALL) {
                let letNewData = state?.sumOFByTimeForALL?.reduce((acc, obj) => {
                    var index = acc.find((item) => item);
                    if (index) {
                        index.lessThan24HoursOld += obj.lessThan24HoursOld;
                        index.between1And5DaysOld += obj.between1And5DaysOld;
                        index.between5And10DaysOld += obj.between5And10DaysOld;
                        index.between10And20DaysOld += obj.between10And20DaysOld;
                        index.between21And30DaysOld += obj.between21And30DaysOld;
                        index.over30DaysOld += obj.over30DaysOld;
                        index.preBooking += obj.preBooking;
                        index.between1to10Days += obj.between1to10Days;
                        index.between11And20Days += obj.between11And20Days;
                        index.between21And30Days += obj.between21And30Days;
                        index.overdueOver30DaysOld += obj.overdueOver30DaysOld;
                        // index.overdueArchived += obj.overdueArchived;
                        // index.total += obj.total;
                        return acc;
                    }
                    acc.push({ ...obj });
                    return acc;
                }, []);
                indexObj = letNewData.find((item) => item);
                indexObj.bn = '';
                setState((st) => ({ ...st, byTimeObj: indexObj, byTimeBranch: val }));
            }
        } else {
            indexObj = state.sumOFByTimeForALL.find((n) => n.bn === val);
            setState((st) => ({ ...st, byTimeObj: indexObj, byTimeBranch: val }));
        }
    };

    const handleDate = (val) => {
        if (val._reactName === 'onChange') {
            setState((st) => ({ ...st, assignedDate: val.target.value }));
        } else {
            setState((st) => ({ ...st, assignedDate: val }));
        }
    };

    const GoToSales = (val) => {
        localStorage.setItem('currentNewWorkflowId', val.workflowID);
        localStorage.setItem('NewSalesDashParams', '{}');
        let searchQuery = `?ProcessId=${props.processID}`;
        history.push({
            pathname: `/NewSalesListView`,
            search: searchQuery
        });
    };

    const DateObj = [
        {
            assignedDateObj: [
                { time: 1, label: 'Less Than 24Hr', BarColor: '5px solid #00F433', value: state.byTimeObj?.lessThan24HoursOld },
                { time: 2, label: '1 to 5 Days', BarColor: '5px solid #88EBA4', value: state.byTimeObj?.between1And5DaysOld },
                { time: 3, label: '5 to 10 Days', BarColor: '5px solid #FFBF00', value: state.byTimeObj?.between5And10DaysOld },
                { time: 4, label: '10 to 20 Days', BarColor: '5px solid #FFE28A', value: state.byTimeObj?.between10And20DaysOld },
                { time: 5, label: '20 to 30 Days', BarColor: '5px solid #bc4443', value: state.byTimeObj?.between21And30DaysOld },
                { time: 6, label: 'Over 30 Days', BarColor: '5px solid #F11C0E', value: state.byTimeObj?.over30DaysOld }
            ],
            OverDateObj: [
                { dueTime: 1, label: 'Pre Booking', BarColor: '5px solid #88EBA4', value: state.byTimeObj?.preBooking },
                { dueTime: 2, label: '1 to 10 Days', BarColor: '5px solid #FFBF00', value: state.byTimeObj?.between1to10Days },
                { dueTime: 3, label: '10 to 20 Days', BarColor: '5px solid #FFE28A', value: state.byTimeObj?.between11And20Days },
                { dueTime: 4, label: '20 to 30 Days', BarColor: '5px solid #bc4443', value: state.byTimeObj?.between21And30Days },
                { dueTime: 5, label: 'Over 30 Days', BarColor: '5px solid #F11C0E', value: state.byTimeObj?.overdueOver30DaysOld }
                // { dueTime: -1, label: 'Archived', BarColor: '5px solid #F11C0E', value: state.byTimeObj?.overdueArchived }
            ]
        }
    ];

    let getDateObj = state.assignedDate == 1 ? DateObj[0].assignedDateObj : DateObj[0].OverDateObj;

    const handleChangeByTime = (e) => {
        const valueByTime = e.target.value;
        const tempData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        // props.getbranchByOnchange(valueByTime);
        findByTimeValues(valueByTime);

        localStorage.setItem(
            'FiltterParams',
            JSON.stringify({
                branchShortName: valueByTime !== 'Default' ? valueByTime : ''
            })
        );

        if (valueByTime !== 'Default') {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...tempData,
                    BranchBytime: valueByTime,
                    selectedValueByTech: valueByTime
                })
            );
        }
    };
    const handleDates = (item) => {
        let tempData = JSON.parse(localStorage.getItem('NewSalesDashParams'));
        localStorage.setItem(
            'NewSalesDashParams',
            JSON.stringify({ returnReason: item.rr, branchShortName: item.bn, branchTime: item.time, dueTime: item.dueTime })
        );
        localStorage.setItem('currentNewWorkflowId', item.workflowID ? item.workflowID : 'All');
        history.push(`/NewSalesListView?ProcessID=${props.processID}`);
    };

    const handle2Dates = (item) => {
        localStorage.setItem('NewSalesDashParams', JSON.stringify({ assignedUser: item.userName }));
        localStorage.setItem('currentNewWorkflowId', item.workflowID ? item.workflowID : 'All');
        history.push(`/NewSalesListView?ProcessID=${props.processID}`);
    };
    const handle3Dates = (item) => {
        localStorage.setItem('NewSalesDashParams', JSON.stringify({ rr: item.rr }));
        localStorage.setItem('currentNewWorkflowId', item.workflowID ? item.workflowID : 'All');
        history.push(`/NewSalesListView?ProcessID=${props.processID}`);
    };

    useEffect(() => {
        if (state.assignedUser) {
            let filteredAssignedList = state.assignedUserList.filter((a) => a.workflowID == state.assignedUser);
            setState((st) => ({
                ...st,
                filteredAssignedList
            }));
        }
    }, [state.assignedUser]);

    const handleAssignedUserTitle = (val) => {
        if (val._reactName === 'onChange') {
            setState((st) => ({ ...st, assignedUser: val.target.value }));
        } else {
            setState((st) => ({ ...st, assignedUser: val }));
        }
    };

    const handleReturnReasonsTitle = (val) => {
        if (val._reactName === 'onChange') {
            setState((st) => ({ ...st, returnReasonTitle: val.target.value }));
        } else {
            setState((st) => ({ ...st, returnReasonTitle: val }));
        }
    };

    return (
        <div
            className="Parts_Dash_Main_Container custom-scroll"
            style={{ padding: '10px', overflow: 'auto', height: 'calc(100vh - 185px)', background: '#f5f5f5' }}
        >
            {showLoader ? (
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: '100%'
                    }}
                >
                    <CircularProgress style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                </div>
            ) : (
                <>
                    {state.salesRecordList.length > 0 && (
                        <Grid container>
                            <div style={{ overflow: 'hidden', display: 'flex', width: '100%' }}>
                                {state.isShowScrollArrow && (
                                    <span onClick={() => scrollPrev()} className="ScrollArrow-Container">
                                        <ChevronLeftIcon />
                                    </span>
                                )}
                                <div style={{ overflow: 'auto', display: 'flex', width: '100%' }} className={`btn-container`} id="WorkFlow-Btn">
                                    {state.salesRecordList.map((m, i) => (
                                        <div item style={{ padding: state.isShowScrollArrow ? '0px 5px 0px 0px' : `0px 5px 0px ${i === 0 ? '10px' : '0px'}` }}>
                                            <SalesRecordCard
                                                workflowData={m}
                                                workflow={m?.workflow}
                                                total={m?.total}
                                                classes={{ root: classes.root }}
                                                onClick={GoToSales}
                                            />
                                        </div>
                                    ))}
                                    <div item style={{ padding: '0px 5px 0px 0px' }}>
                                        <SalesRecordCard workflow="Total" total={state.salesRecordAllTotal} classes={{ root: classes.root }} />
                                    </div>
                                </div>
                                {state.isShowScrollArrow && (
                                    <span onClick={() => scrollNext()} className="ScrollArrow-Container">
                                        <ChevronRightIcon />
                                    </span>
                                )}
                            </div>
                        </Grid>
                    )}
                    <Grid item container xs={12} style={{ padding: 5, boxSize: 'none' }}>
                        {state.showHeaderLoader ? (
                            <div className={classes.root}>
                                <div className="pieChartSize" style={{ display: 'flex' }}>
                                    <CircularProgress style={{ marginLeft: 'auto', marginRight: 'auto', alignSelf: 'center' }} />
                                </div>
                            </div>
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    <CardUserInterface
                                        branchDropDown={state.uniqueBranches}
                                        branchValue={state.byTimeBranch}
                                        title={WipsDate}
                                        titleClick={handleDate}
                                        titleValue={state.assignedDate}
                                        mainList={getDateObj}
                                        branchClick={handleChangeByTime}
                                        bodyClick={handleDates}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CardUserInterface
                                        hideBranch={true}
                                        mainTitle="SALES ASSIGNED"
                                        title={state.assignuserTitles}
                                        titleClick={handleAssignedUserTitle}
                                        titleValue={state.assignedUser}
                                        mainList={state.filteredAssignedList}
                                        bodyClick={handle2Dates}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CardUserInterface
                                        mainTitle="RETURN REASONS"
                                        branchDropDown={state.uniqueBranches}
                                        branchValue={state.byTimeBranch}
                                        title={state.returnReasonTitleList}
                                        titleClick={handleReturnReasonsTitle}
                                        titleValue={state.returnReasonTitle}
                                        mainList={state.returnReasonList}
                                        branchClick={handleChangeByTime}
                                        bodyClick={handle3Dates}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </>
            )}
        </div>
    );
};

export default NewSalesDashboardDetailsScreen;
